import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ClosePeriod, ClassMapper, CacheService } from '@mapfre-tech/amap3';
import * as _ from 'lodash';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
   providedIn: "root"
})
export class ClosePeriodService {
   constructor(private http: HttpClient, private cacheService: CacheService) { }

   className = 'ClosePeriodService';

   getAllClosePeriods(cache = true, cacheKey = "allClosePeriods"): Observable<ClosePeriod[]> {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         const observable = this.http.get<ClosePeriod[]>(environment.base_URL + "/close-periods").pipe(
            map(res => {   
               res = ClassMapper.fromJSONArray(res, ClosePeriod);
               this.cacheService.updateCacheData(res, cacheKey)
               return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

   getClosePeriodsByExercise(exercise, cache = true, cacheKey = "closePeriodsExercise"): Observable<ClosePeriod[]> {
      const params = new HttpParams().set('exercise', exercise);
      if (cache && this.cacheService.canUseCache(cacheKey, [exercise.toString()])) {
         return this.cacheService.getCacheData(cacheKey, [exercise.toString()]);
       } else {
         const observable = this.http.get<ClosePeriod[]>(environment.base_URL + "/close-periods", { params: params }).pipe(
            map(res => {
               const result = ClassMapper.fromJSONArray(res, ClosePeriod);
               this.cacheService.updateCacheData(result, cacheKey, [exercise.toString()])
               return result;
            })
         );
         this.cacheService.updateCacheReq(cacheKey, [exercise.toString()]);
         return observable;
      }
   }

   newClosePeriod(newClosePeriod) {
      return this.http.post(environment.base_URL + "/close-periods", newClosePeriod);
   }

   updateClosePeriod(editedClosePeriod, closePeriodId) {
      return this.http
         .put(environment.base_URL + `/close-periods/${closePeriodId}`, editedClosePeriod)
   }

}
